import { gql } from '@apollo/client';

export const FRAGMENT_MONITOR = gql`
    fragment monitor on Monitor {
        shortName
        idNumber
        windowsTimeZone
        isStationary
        gpsHorizontalMovementToleranceMetres
        gpsVerticalMovementToleranceMetres
        location {
            elevation
            latitude
            longitude
            activeFromTime
        }
        preferredSurfaceWeatherStation {
            id
        }
        isVisible
        height
    }

    fragment noiseMonitor on NoiseMonitor {
        lAeqProcessVariableId
    }

    fragment discreteReceptor on DiscreteReceptor {
        calpuffConfigurations {
            id
            name
        }
    }
`;
